export enum TellentSsoMode {
  Off = 'off',
  Test = 'test',
  Force = 'force',
}

export type TellentSsoSwitchableMode = TellentSsoMode.Test | TellentSsoMode.Force;

export enum TellentSsoStep {
  Saml = 'saml',
  Xml = 'xml',
  Roles = 'roles',
  TestMode = 'config',
  ForceMode = 'force',
}

export type TellentSsoAppRole = { appGuid: string; roleExternalId: string };

export interface TellentSso {
  configDetails: {
    acsUrl: string;
    entityId: string;
    spEntityIds: string[];
    spMetadataUrl: string;
  };
  identityProvider: null | {
    defaultSeats: TellentSsoAppRole[];
    id: number;
    metadataXmlFilename: string;
    mode: TellentSsoMode;
    signInUrl: string;
    source: string;
    tokenExpirationHours: number;
  };
}

export const TellentSsoStepOrder = [
  TellentSsoStep.Saml,
  TellentSsoStep.Xml,
  TellentSsoStep.Roles,
  TellentSsoStep.TestMode,
  TellentSsoStep.ForceMode,
];
